const IMAGE_EXTS = new Set(["png", "jpeg", "jpg", "webp", "gif", "bmp", "tiff"]);

function sanitizeImageExtension(name) {
  const parts = name.split(".");
  if (parts.length < 3) return name;
  const last = parts[parts.length - 1].toLowerCase();
  const prev = parts[parts.length - 2].toLowerCase();
  if (IMAGE_EXTS.has(last) && IMAGE_EXTS.has(prev)) {
    return parts.slice(0, parts.length - 1).join(".");
  }
  return name;
}

export function buildDownloadName(url) {
  const clean = (url || "").split("?")[0].split("#")[0];
  let name = clean.split("/").pop() || "image";
  if (!name.includes(".")) name = `${name}.png`;
  return sanitizeImageExtension(name);
}

export function buildDownloadUrl(url, format) {
  const filename = buildDownloadName(url);
  const params = new URLSearchParams({ url, filename });
  if (format) params.set("format", format);
  return `/api/fast/media/download?${params.toString()}`;
}

/**
 * Télécharge un fichier via Blob URL pour éviter toute navigation de page.
 * Compatible PWA standalone iOS/Android.
 */
export async function downloadFile(url, filename) {
  const apiUrl = buildDownloadUrl(url);
  const res = await fetch(apiUrl);
  if (!res.ok) throw new Error(`Download failed: ${res.status}`);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename || buildDownloadName(url);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(objectUrl), 2000);
}
